import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Footer from './components/footer';
import Contact from "./pages/contact";
import Product from "./pages/products";
import ScrollToTop from './components/ScrollToTop';
import Sidebar from './components/sidebar';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Header from "./components/header";
import AddProduct from './pages/add-product';
import Producttype from './pages/Producttype';
import Addtype from './pages/Add-type';
import { Provider } from 'react-redux';
import store from './redux-toolkit/Store';
import Login from './pages/login';
import Cookies from 'js-cookie';
import { ToastContainer } from 'react-toastify';
import Blog from './pages/Blog';
import Blogedit from './pages/Blog-edit';
import Feedback from './pages/Feedback';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if the token exists in Cookies on initial load
    const token = Cookies.get("token");
    setIsAuthenticated(!!token);
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer />
        {isAuthenticated ? (
          <main className="app-layout">
            <div className="main-content">
              <div className="main-wrapper">
                <>
                  <Header />
                  <button className="toggle-button" onClick={toggleSidebar}>
                    ☰
                  </button>
                  <Sidebar setIsAuthenticated={setIsAuthenticated} isOpen={isSidebarOpen} />
                  <Routes>
                    <Route path="/" element={<Navigate to="/product" replace />} />
                    <Route path="/product" element={<Product />} />
                    <Route path="/add-product" element={<AddProduct />} />
                    <Route path="/Productstype" element={<Producttype />} />
                    <Route path="/add" element={<Addtype />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/Blog" element={<Blog />} />
                    <Route path="/blog-edit" element={<Blogedit />} />
                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="*" element={<Navigate to="/product" replace />} />
                  </Routes>
                  <Footer />
                </>
              </div>
            </div>
          </main>
        ) : (
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </BrowserRouter>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);



